import type { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Loading } from '@/components/ui/old/Loading';

import { useAssetsFilters } from '../hooks/use-assets-filters';
import { GetStaticData } from '../queries/get-static-data';

import { FallbackSiteUnavailable } from './fallback';

export type DataPreloadProps = PropsWithChildren<{}>;

export function DataPreload({ children }: DataPreloadProps) {
  const { siteId } = useParams<{ siteId: string }>();
  const [assetsFilters] = useAssetsFilters();

  const staticData = GetStaticData.useQuery({
    siteId,
    date: assetsFilters.date,
  });

  if (staticData.isLoading) {
    return <Loading />;
  }

  if (staticData.isError) {
    Sentry.captureException(staticData.error);

    return (
      <FullPageContent testId="3d-view-unavailable">
        <FallbackSiteUnavailable />
      </FullPageContent>
    );
  }

  return <>{children}</>;
}
